import React, { useEffect, useState } from "react";
import API from "../axios";
import "../style/myperform.css";

const MyPerformance = () => {

  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");

  const [loading, setLoading] = useState(false);
  const [performanceData, setPerformanceData] = useState([]);

  const getCurrentMonthDates = () => {
    const now = new Date();

    const firstDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      1
    );

    const lastDay = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    );

    return {
      fromdate: formatDate(firstDay),
      todate: formatDate(lastDay),
    };
  };

  const formatDate = (date) => {

      const year = date.getFullYear();

      const month = String(date.getMonth() + 1)
        .padStart(2, "0");

      const day = String(date.getDate())
        .padStart(2, "0");

      return `${year}-${month}-${day}`;
    };

  const currentMonth = getCurrentMonthDates();

  const [fromDate, setFromDate] = useState(currentMonth.fromdate);
  const [toDate, setToDate] = useState(currentMonth.todate);

  const fetchPerformance = async () => {
    try {

      setLoading(true);

      const res = await API.post("/myPerform", {
        empcode: empDetails.employee_code,
        fromdate: fromDate,
        todate: toDate,
      });

      setPerformanceData(res.data.salesIncData || []);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }
  };

  useEffect(() => {
    if (empDetails?.employee_code) {
      fetchPerformance();
    }
  }, []);

  const totals = performanceData.reduce(
    (acc, item) => {
      acc.dia += Number(item.DiaNetwt || 0);
      acc.gold += Number(item.GoldNetwt || 0);
      acc.silver += Number(item.SilverNetwt || 0);
      acc.plat += Number(item.PlatNetwt || 0);
      acc.mrp += Number(item.MRPNetwt || 0);

      return acc;
    },
    {
      dia: 0,
      gold: 0,
      silver: 0,
      plat: 0,
      mrp: 0,
    }
  );

  const formatIndianCurrencyShort = (value) => {

  const num = Number(value || 0);

  if (num >= 10000000) {
    return (num / 10000000).toFixed(1).replace(".0", "") + "Cr";
  }

  if (num >= 100000) {
    return (num / 100000).toFixed(1).replace(".0", "") + "L";
  }

  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(".0", "") + "K";
  }

  return num.toLocaleString("en-IN");
};

  return (

    <div className="container mt-3">

      <h4 className="pageHeader text-center mb-lg-4 mb-3">
        My Performance
      </h4>

      <div className="row g-2 align-items-end filtertext ">

        <div className="col-md-3 col-4">
          <label className="fw-bold mb-1">From Date</label>

          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="col-md-3 col-4">
          <label className="fw-bold mb-1">To Date</label>

          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="col-md-2 col-4">
          <button
            className="btn btn-dark w-100 filterBtn"
            onClick={fetchPerformance}
          >
            Filter
          </button>
        </div>

      </div>

      <div className="tableWrapper mt-4">

        {
          loading ?

          <div className="text-center py-4">
            Loading...
          </div>

          :

          <div className="table-responsive">

            <table className="table table-bordered performanceTable text-center align-middle">

              <thead>

                <tr>
                  <th>Date </th>
                  <th>Dia Wt <small>( g )</small></th>
                  <th>Gold Wt <small>( g )</small></th>
                  <th>Silver Wt <small>( g )</small></th>
                  <th>Plat Wt <small>( g )</small></th>
                  <th>MRP Wt <small>( g )</small></th>
                </tr>

              </thead>

              <tbody>

                {
                  performanceData.length > 0 ?

                  performanceData.map((item, index) => (

                    <tr key={index}>

                      <td>
                        {
                          new Date(item.DAT)
                          .toLocaleDateString("en-GB")
                        }
                      </td>

                      <td>
                        {Number(item.DiaNetwt || 0)
                          .toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 3,
                          })}
                      </td>

                      <td>
                        {Number(item.GoldNetwt || 0)
                          .toLocaleString("en-IN")}
                      </td>

                      <td>
                        {Number(item.SilverNetwt || 0)
                          .toLocaleString("en-IN")}
                      </td>

                      <td>
                        {Number(item.PlatNetwt || 0)
                          .toLocaleString("en-IN")}
                      </td>

                      {/* <td>
                        ₹ {Number(item.MRPNetwt || 0)
                          .toLocaleString("en-IN")}
                      </td> */}
                      
                      <td>
                      ₹ {formatIndianCurrencyShort(item.MRPNetwt)}
                    </td>

                    </tr>

                  ))

                  :

                  <tr>

                    <td colSpan="6" className="py-4">
                      No Data Found
                    </td>

                  </tr>
                }

              </tbody>

              <tfoot>

                <tr className="totalRow">

                  <td>Total</td>

                  <td>
                    {totals.dia.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>

                  <td>{totals.gold.toLocaleString("en-IN")}</td>

                  <td>{totals.silver.toLocaleString("en-IN")}</td>

                  <td>{totals.plat.toLocaleString("en-IN")}</td>

                  {/* <td>₹ {totals.mrp.toLocaleString("en-IN")}</td> */}
                  <td>
                    ₹ {formatIndianCurrencyShort(totals.mrp)}
                  </td>

                </tr>

              </tfoot>

            </table>

          </div>
        }

      </div>

    </div>
  );
};

export default MyPerformance;